import { resolveApiPath } from '@/app/constants';
import type { TaskInfo } from '@/app/types';
import type { TaskState } from './types';

export const TASK_PAGE_SIZE = 20;

export const TASK_COUNT_URL = resolveApiPath('/vidu/v1/tasks/count');
export const PROCESSING_TASK_STATES: TaskState[] = ['created', 'queueing', 'preparation', 'scheduling', 'processing'];

export const VIDEO_TASK_TYPES: Record<'toolPage' | 'templatePage' | 'text2audio', TaskInfo['type'][]> = {
  toolPage: [
    'img2video',
    'character2video',
    'text2video',
    'reference2image',
    'text2image',
    'image_edit',
    'video_edit',
    'upscale',
    'extend',
    'headtailimg2video',
    'multi_frame',
    'controlnet',
    'material2video',
    'video2extend',
    'video2extail',
    'face_swap',
    'upscale_image',
    'one_click',
    'music_video',
    'lip_sync',
    'remake',
    'short_story',
    'style_transfer',
    'motion_control',
  ],
  templatePage: ['scene', 'upscale'],
  text2audio: ['text2audio'],
};
